<button class="hint-chip__chip d-inline-flex align-items-center gap-1 mat-font-body-sm"
        [matMenuTriggerFor]="fileMenu">
  <mat-icon class="mat-icon-sm mat-text-primary">{{ icon() }}</mat-icon>
  <span class="hint-chip__label">{{ ref().filename }}</span>
  <mat-icon class="mat-icon-sm mat-text-on-surface-variant">arrow_drop_down</mat-icon>
</button>

<mat-menu #fileMenu="matMenu">
  @if (authUrl()) {
    <button mat-menu-item (click)="download()">
      <mat-icon>download</mat-icon><span>Download</span>
    </button>
  }
  @if (isViewable()) {
    <button mat-menu-item (click)="view()" [disabled]="viewing()">
      <mat-icon>{{ isGeoJson() ? 'data_object' : 'open_in_new' }}</mat-icon>
      <span>{{ viewing() ? 'Loading…' : 'View' }}</span>
    </button>
  }
  @if (isGeoJson()) {
    <button mat-menu-item (click)="addToMap()" [disabled]="loaded()">
      <mat-icon>map</mat-icon>
      <span>{{ loaded() ? 'Added to map' : 'Add to map' }}</span>
    </button>
  }
</mat-menu>
